// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-edit-match__container {
    padding: 0 var( --space-x3 );
}

.tournament-edit-match__first-last-name__container {
    display: flex;
    align-items: center;
    gap: 68px;
}

.tournament-edit-match__date-time__container {
    display: flex;
    /* width: 50%; */
    /* padding-right: 32px; */
    justify-content: space-between;
    align-items: flex-start;
    gap: 70px;
}

.tournament-edit-match__date-time__container .input-field {
    margin-bottom: 0;
    width: 100%;
}

.tournament-edit-match__local-visitor__input {
    width: 100%;
}

.tournament-edit-match__local-visitor__input:first-of-type {
    margin-right: var( --space-x2 );
}
.tournament-edit-match__local-visitor__input:last-of-type {
    margin-left: var( --space-x2 );
}

.tournament-edit-match__city__input {
    margin-right: var( --space-x2 );
    margin-top: calc( var( --space-x3 ) + var( --space ) );
    margin: calc( var( --space-x3 ) + var( --space ) ) var( --space-x2 ) 0 0;
}

.tournament-edit-match__field__input {
    margin: calc( var( --space-x3 ) + var( --space ) ) 0 0 var( --space-x2 );
}

.tournament-edit-match__city__input,
.tournament-edit-match__field__input {
    width: 100%;
}

.tournament-edit-match__city-field__container {
    display: flex;
    justify-content: space-between;
}

.tournament-edit-match__first-last-name__container .input-field {
    margin-top: calc( var( --space-x3 ) + var( --space-x2 ) );
    margin-bottom: 0;
}

.tournament-edit-match__referee__container {
    display: flex;
    justify-content: space-between;
    margin-top: var( --space );
}

.tournament-edit-match__referee__container-column {
    width: 100%;
}

.tournament-edit-match__referee__container-column:first-of-type {
    margin-right: var( --space-x2 );
}
.tournament-edit-match__referee__container-column:last-of-type {
    margin-left: var( --space-x2 );
}

.tournament-edit-match__referee__container-input {
    margin-bottom: calc( var( --space-x3 ) + var( --space ) );
}

.tournament-edit-match__referee___btn-add {
    margin-top: var( --space-x2 );
    margin-bottom: var( --space-x2 );
}

.tournament-edit-match__referee__container-column_label .baloa-username{
    font-style: initial;
    color: var(--primary-very-dark-color);
}

.tournament-edit-match__city__input .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.tournament-edit-match__field__input .input-field-input{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background: var(--white-color);
}

.tournament-edit-match__date-time__container .new-match__form__elements__date__input .input-field-input,
.tournament-edit-match__date-time__container .tournament-edit-match__date-input .input-field-input{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background: var(--white-color);
    max-height: unset;
    padding: 14px;
}

.tournament-edit-match_referee_general_container .baloa-table{
    font-weight: var(--font-medium);
    color:var(--primary-very-dark-color);
    margin: 30px 0;
}

.tournament-edit-match__input-match_assigner{
    width: 47%;
}

.tournament-edit-match__referee__container-column_label .search_members_staff_edit_content .MuiListItem-container{
    background-color: var(--white-color);
}

/* .tournament-edit-match__referee__container-column .official_referee_input,
.second_assistant_referee_input{
    margin-bottom: var(--space-x2);
} */

/* .tournament-edit-match__referee__container-column .third_assistant_referee_input{
    margin-bottom: var(--space-x2);
} */

.tournament-edit-match__referee__container-column .input-field-autocomplete div,
.tournament-edit-match__input-match_assigner .input-field-autocomplete div{
    background: var(--white-color);
}

.tournament_edit_match_payment_title{
    margin: var(--space-and-half) 0;
}

.tournament_edit_match_payment_title.baloa-table{
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.tournament_edit_match__payment_settings {
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
    margin-bottom: var(--space-and-half);
}

.tournament_edit_match__payment_settings__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament_edit_match__payment_settings__saved-config {
    padding: var(--space);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
}

.tournament_edit_match__payment_settings__saved-config__total-fee .baloa-table-column {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
}

.tournament_edit_match__payment_settings__saved-config__total-fee .baloa-username {
    color: var(--primary-very-dark-color);
}

.tournament_edit_match_form_elements_input_value{
    display: flex;
    align-items: center;
}

.tournament_edit_match_form_elements_input_value .MuiAutocomplete-root {
    width: 100%;
}

.tournament_edit_match_form_elements_input_value .baloa-username {
    color: var(--primary-very-dark-color);
    white-space: nowrap;
    padding: var(--space) var(--space-half);
    border-top: 1px solid var(--new-gray-background-color);
    border-right: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    border-radius: 0 var(--space-half) var(--space-half) 0;
}

.tournament_edit_match_form_elements_input_value .baloa-username.selected {
    padding: calc( var(--space) + var(--space-quarter) ) var(--space-half);
}

.MuiFormControl-root.select-action-btn__container.edit-match__selector__add.day {
    width: 25%;
    margin-bottom: 20px;
}

.new-match__form__elements__content__input .input-field-validation label,
.new-match__form__elements__date__input .input-field-label,
.edit-match__selector__add label,
.tournament-edit-match__first-last-name__container .MuiFormControl-root.select-tournament-team__container  {
    font-weight: var(--font-regular);
    line-height: 16px;
    font-size: 14px;
    color: var(--primary-very-dark-color);
}

.tournament-edit-match__first-last-name__container .MuiFormControl-root.select-tournament-team__container label {
    margin-bottom: 4px;
}

.edit-match__selector__add label {
    margin-top: 12px;
}

.tournament-edit-match_referee_general_container {
    padding: 16px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
}

.tournament-edit-match__container .select-tournament-team__container .MuiSelect-selectMenu {
    color: var(--primary-very-dark-color);
}

.tournament-edit-match__container .MuiTypography-colorTextSecondary {
    color: var(--primary-dark-color);
}

.tournament-edit-match___form__elements__date__input {
    width: 100%;
}

.tournament-edit-match___form__elements__date__input_selected_date {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 18px;
    background: var(--white-color);
    top: -40px;
    margin-right: 5px;
}

.edit-match__selector__add.clear .MuiSelect-icon {
    color: transparent;
}

.tournament-edit-match__form__elements__input_field {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 20px;
    top: -36px;
    margin-right: 7px;
}

.tournament_edit_match_form_elements_input_value.with-payment .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root {
    border-radius: 8px 0 0 8px;
}

.tournament_edit_match_form_elements_input_value.with-payment .search_members_staff_edit_content .MuiListItem-container {
    border-radius: 8px 0 0 8px;
}

#menu-field .MuiPaper-root {
    top: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-edit-match-modal/TournamentEditMatchModal.styles.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,sDAAsD;IACtD,wEAAwE;AAC5E;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yDAAyD;IACzD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;;IAEI,kDAAkD;IAClD,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;;IAEI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,kDAAkD;IAClD,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yDAAyD;AAC7D;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,uCAAuC;IACvC,sDAAsD;IACtD,wDAAwD;IACxD,yDAAyD;IACzD,sDAAsD;AAC1D;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;;;;IAII,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;IAC9B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".tournament-edit-match__container {\n    padding: 0 var( --space-x3 );\n}\n\n.tournament-edit-match__first-last-name__container {\n    display: flex;\n    align-items: center;\n    gap: 68px;\n}\n\n.tournament-edit-match__date-time__container {\n    display: flex;\n    /* width: 50%; */\n    /* padding-right: 32px; */\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 70px;\n}\n\n.tournament-edit-match__date-time__container .input-field {\n    margin-bottom: 0;\n    width: 100%;\n}\n\n.tournament-edit-match__local-visitor__input {\n    width: 100%;\n}\n\n.tournament-edit-match__local-visitor__input:first-of-type {\n    margin-right: var( --space-x2 );\n}\n.tournament-edit-match__local-visitor__input:last-of-type {\n    margin-left: var( --space-x2 );\n}\n\n.tournament-edit-match__city__input {\n    margin-right: var( --space-x2 );\n    margin-top: calc( var( --space-x3 ) + var( --space ) );\n    margin: calc( var( --space-x3 ) + var( --space ) ) var( --space-x2 ) 0 0;\n}\n\n.tournament-edit-match__field__input {\n    margin: calc( var( --space-x3 ) + var( --space ) ) 0 0 var( --space-x2 );\n}\n\n.tournament-edit-match__city__input,\n.tournament-edit-match__field__input {\n    width: 100%;\n}\n\n.tournament-edit-match__city-field__container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-edit-match__first-last-name__container .input-field {\n    margin-top: calc( var( --space-x3 ) + var( --space-x2 ) );\n    margin-bottom: 0;\n}\n\n.tournament-edit-match__referee__container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: var( --space );\n}\n\n.tournament-edit-match__referee__container-column {\n    width: 100%;\n}\n\n.tournament-edit-match__referee__container-column:first-of-type {\n    margin-right: var( --space-x2 );\n}\n.tournament-edit-match__referee__container-column:last-of-type {\n    margin-left: var( --space-x2 );\n}\n\n.tournament-edit-match__referee__container-input {\n    margin-bottom: calc( var( --space-x3 ) + var( --space ) );\n}\n\n.tournament-edit-match__referee___btn-add {\n    margin-top: var( --space-x2 );\n    margin-bottom: var( --space-x2 );\n}\n\n.tournament-edit-match__referee__container-column_label .baloa-username{\n    font-style: initial;\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-edit-match__city__input .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"]{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.tournament-edit-match__field__input .input-field-input{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background: var(--white-color);\n}\n\n.tournament-edit-match__date-time__container .new-match__form__elements__date__input .input-field-input,\n.tournament-edit-match__date-time__container .tournament-edit-match__date-input .input-field-input{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background: var(--white-color);\n    max-height: unset;\n    padding: 14px;\n}\n\n.tournament-edit-match_referee_general_container .baloa-table{\n    font-weight: var(--font-medium);\n    color:var(--primary-very-dark-color);\n    margin: 30px 0;\n}\n\n.tournament-edit-match__input-match_assigner{\n    width: 47%;\n}\n\n.tournament-edit-match__referee__container-column_label .search_members_staff_edit_content .MuiListItem-container{\n    background-color: var(--white-color);\n}\n\n/* .tournament-edit-match__referee__container-column .official_referee_input,\n.second_assistant_referee_input{\n    margin-bottom: var(--space-x2);\n} */\n\n/* .tournament-edit-match__referee__container-column .third_assistant_referee_input{\n    margin-bottom: var(--space-x2);\n} */\n\n.tournament-edit-match__referee__container-column .input-field-autocomplete div,\n.tournament-edit-match__input-match_assigner .input-field-autocomplete div{\n    background: var(--white-color);\n}\n\n.tournament_edit_match_payment_title{\n    margin: var(--space-and-half) 0;\n}\n\n.tournament_edit_match_payment_title.baloa-table{\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament_edit_match__payment_settings {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament_edit_match__payment_settings__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament_edit_match__payment_settings__saved-config {\n    padding: var(--space);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.tournament_edit_match__payment_settings__saved-config__total-fee .baloa-table-column {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.tournament_edit_match__payment_settings__saved-config__total-fee .baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament_edit_match_form_elements_input_value{\n    display: flex;\n    align-items: center;\n}\n\n.tournament_edit_match_form_elements_input_value .MuiAutocomplete-root {\n    width: 100%;\n}\n\n.tournament_edit_match_form_elements_input_value .baloa-username {\n    color: var(--primary-very-dark-color);\n    white-space: nowrap;\n    padding: var(--space) var(--space-half);\n    border-top: 1px solid var(--new-gray-background-color);\n    border-right: 1px solid var(--new-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n    border-radius: 0 var(--space-half) var(--space-half) 0;\n}\n\n.tournament_edit_match_form_elements_input_value .baloa-username.selected {\n    padding: calc( var(--space) + var(--space-quarter) ) var(--space-half);\n}\n\n.MuiFormControl-root.select-action-btn__container.edit-match__selector__add.day {\n    width: 25%;\n    margin-bottom: 20px;\n}\n\n.new-match__form__elements__content__input .input-field-validation label,\n.new-match__form__elements__date__input .input-field-label,\n.edit-match__selector__add label,\n.tournament-edit-match__first-last-name__container .MuiFormControl-root.select-tournament-team__container  {\n    font-weight: var(--font-regular);\n    line-height: 16px;\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-edit-match__first-last-name__container .MuiFormControl-root.select-tournament-team__container label {\n    margin-bottom: 4px;\n}\n\n.edit-match__selector__add label {\n    margin-top: 12px;\n}\n\n.tournament-edit-match_referee_general_container {\n    padding: 16px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n}\n\n.tournament-edit-match__container .select-tournament-team__container .MuiSelect-selectMenu {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-edit-match__container .MuiTypography-colorTextSecondary {\n    color: var(--primary-dark-color);\n}\n\n.tournament-edit-match___form__elements__date__input {\n    width: 100%;\n}\n\n.tournament-edit-match___form__elements__date__input_selected_date {\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-left: 18px;\n    background: var(--white-color);\n    top: -40px;\n    margin-right: 5px;\n}\n\n.edit-match__selector__add.clear .MuiSelect-icon {\n    color: transparent;\n}\n\n.tournament-edit-match__form__elements__input_field {\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-left: 20px;\n    top: -36px;\n    margin-right: 7px;\n}\n\n.tournament_edit_match_form_elements_input_value.with-payment .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root {\n    border-radius: 8px 0 0 8px;\n}\n\n.tournament_edit_match_form_elements_input_value.with-payment .search_members_staff_edit_content .MuiListItem-container {\n    border-radius: 8px 0 0 8px;\n}\n\n#menu-field .MuiPaper-root {\n    top: 20px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
